import React from 'react'


export type Context = {
  store: {
    has: () => void,
    getState: () => ReduxState,
    subscribe: (key: string, handler: (state: ReduxState) => void) => void,
    dispatch: () => void,
  },
  storeEvents: {
    subscribe: (reducerName: string, handler: (state: ReduxState) => void) => void,
    unsubscribe: (reducerName: string, handler: (state: ReduxState) => void) => void,
    dispatch: (newState: ReduxState, { type, rootType }) => void
  }
}

const StoreContext = React.createContext<Context>({
  store: {
    has: () => {},
    getState: () => ({}),
    subscribe: () => {},
    dispatch: () => {},
  },
  storeEvents: {
    unsubscribe: () => {},
    subscribe: () => {},
    dispatch: () => {},
  },
})


export default StoreContext
